<template>
    <PageHeader />
    <main class="main">
        <div class="container">
            <router-view/>
        </div>
    </main>
    <PageFooter />
</template>

<script>
import PageHeader from './components/PageHeader.vue';
import PageFooter from './components/PageFooter.vue';
// import './css-globalX/all.css';
export default {
  name: 'App',
    components: {
        PageHeader,
        PageFooter
    }
}
</script>

<style lang="css">   

/* @import "./css-global/all.css"; */
/* @import "./css-global/global.css";
@import "./css-global/variables.css";
@import "./css-global/fonts.css";
@import "./css-global/container.css";
@import "./css-global/grid.css";  */

#app { 
    font-family: 'Open Sans', sans-serif;
    color: var(--csGray);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}
html, body, #app {
    background: var(--csGrayLight);
    color: var(--csGray);
}

.main, .fieldset, .table-wrap {
    box-shadow: var(--shadow);
    border-radius: var(--radius);
    padding: var(--gutter);
}
@media (--xsmall) {
    .main, .fieldset, .table-wrap {
        padding: 10px;
    }
}
html, body {
    height: 100%;
}

html {
    font-size: 16px;
}

.main {
    flex: 1 0 auto;
    margin: 0;

    @media (--xmedium) {
        margin: 30px 0;
    }

    @media (--large) {
        margin: 0 0;
    }
}

a {
    transition: var(--transition);
    color: var(--csBlue);

    &:hover {
        opacity: 0.65;
    }
}

.h1 {
    font-size: 2em;
    margin: 0 0 0.67em;
}

.h2 {
    font-size: 1.5em;
    margin: 0.83em 0 1em;
}

.fieldset {
    border: 1px solid var(--csBorder);
    border-radius: var(--radius);
    padding: 10px;

    @media (--medium) {
        padding: 20px 30px 30px;
    }
}

.fieldset-item {
    @media (--large) {
        margin-right: 25px;

        &:last-child {
            margin-right: 0;
        }
    }
}

.fieldset-item--noLabel {
    @media (--xmedium) {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
    }
}

.fieldset-label {
    display: block;
    font-size: 1rem;
    margin: 10px 0 15px;
}

.input,
.vdp-datepicker input,
.select,
.dropdown-toggle {
    border: 1px solid var(--csBorder) !important;
    border-radius: var(--radius) !important;
    background-color: white !important;
    padding: 10px;
    font-size: 16px !important;
    appearance: none !important;
    width: 100% !important;
    color: var(--csGray) !important;
}

.dropdown.v-select.single.searchable {
    @media (--xmedium) {
        min-width: 360px !important;
        max-width: 460px !important;
    }
}

.v-select .dropdown-toggle .clear {
    bottom: 12px !important;
}

.open-indicator {
    bottom: 8px !important;
}

.dropdown-toggle {
    padding: 4px 10px !important;
}

.vdp-datepicker {
    padding: 0;

    @media (--xmedium) {
        width: 150px;
    }

    .vdp-datepicker__clear-button {
        position: absolute;
        top: 0;
        right: 8px;
        font-size: 30px;

        @media (--large) {
            font-size: 16px;
        }
    }

    .vdp-datepicker__calendar .cell.selected, .vdp-datepicker__calendar .cell.selected.highlighted, .vdp-datepicker__calendar .cell.selected:hover {
        background: var(--csBlue);
        color: white;
    }

    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
        border: 1px solid var(--csBlue);
    }

    .vdp-datepicker__calendar {
        margin-left: -12px;
        margin-right: -12px;
        width: auto;

        @media (--small) {
            width: 300px;
            margin: 0;
        }
    }
}

.vdp-datepicker--right {
    .vdp-datepicker__calendar {
        @media (--small) {
            right: 0;
            left: auto;
        }

        @media (--medium) {
            right: auto;
        }
    }
}

.select {
    background: url(assets/arrow-down.svg) right 10px center white;
    background-repeat: no-repeat;
    padding-right: 35px;
}

.search-first-field {
    @media (--xmedium) {
        min-width: 360px;
        max-width: 460px;
    }
}

.button {
    background: var(--csBlue);
    border: none;
    color: white;
    font-size: 1rem;
    font-weight: 600;
    padding: 1rem 2rem;
    width: 100%;
    transition: var(--transition);
    text-transform: uppercase;
    border-radius: var(--buttonRadius);
    box-shadow: var(--shadow);
    text-align: center;
    @media (--medium) {
        width: auto;
    }

    &:hover,
    &:focus {
        background: var(--csBlueDark);
        text-decoration: none;
        box-shadow: none;
        opacity: 1;
    }
    &:active {
        background: var(--csBlueLight);
        box-shadow: none;
        opacity: 1;
    }
    &:focus-visible {
        outline: 2px solid var(--csBlueLight);
        outline-offset: 2px;
        opacity: 1;
    }
}

.button--small {
    font-size: 14px;
    padding: 0.5em 1em;
    display: block;
}

.button--fieldset {
    margin-top: 30px;
}

.contest-links {
    display: flex;
    flex-direction: column;
    margin-block: 2rem;
    gap: 2rem;

    @media all and (min-width: 1200px) {
        flex-direction: row;

    }
}

.contest-links-item {
    margin: 0;
    display: inline-block;
}

.contest-links-item .link {
    color: var(--csBlue);
    text-decoration: none;
    border: none;
    font-size: 0.85rem;
    font-weight: 600;
    padding: 1rem 0;
    width: 100%;
    transition: var(--transition);
    text-transform: uppercase;

    @media (--medium) {
        width: auto;
    }

    &:hover,
    &:focus {
        color: var(--csBlueDark);
        text-decoration: none;
    }
    &:active {
        color: var(--csBlueLight);
    }
    &:focus-visible {
        outline: 2px solid var(--csBlue);
        border-radius: 24px;
        outline-offset: 1px
    }


}

.contest-links-item span {
    background-image: url(assets/arrowRight.svg);
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: 100%;
    height: 12px;
    width: 9px;
    display: inline-block;
    margin-left: 8px;
}

.contest-links-item a.selected span {
    background-image: url(assets/arrowDown.svg);
}

.results {
    /*overflow-x: scroll;*/
    margin: 50px 0;
}

.table-wrap {
    /* overflow-x: auto; */ /* Enable horizontal scrolling on small screens  - UGASIO ZBOG STICKY HEADERA*/
    margin: 0;
    overflow-scrolling: touch; /* Smooth horizontal scrool on phone */
    -webkit-overflow-scrolling: touch;
    font-size: 0.75rem;
    padding: 0;

    @media (--large) {
        margin: 0;
    }
}

.table {
    width: 100%;
}

.table-row {
    border-bottom: 1px solid var(--csBorder);

    &:first-child {
        border-top: 1px solid var(--csBorder);
        font-weight: 600;
    }

    &:nth-child(2n+1) {
        background: var(--csGrayLight);
    }
}

.table-cell {
    padding: 8px;
    min-width: 200px;
}

.table-cell-content {
    min-width: 200px;
}

.checkbox {
    display: none;

    &:checked + .checkbox-label {
        &::before {
            background-image: url(assets/checkmark.svg);
        }

        &::after {
            animation: checkbox 0.3s ease-out;
        }
    }

}

@keyframes checkbox {
    0% {
        width: 0px;
        height: 0px;
    }

    100% {
        width: 30px;
        height: 30px;
    }
}

.checkbox-label {
    padding-left: 23px;
    position: relative;
    cursor: pointer;

    &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 15px;
        height: 15px;
        border-radius: var(--radius);
        border: 1px solid var(--csBorder);
        display: inline-block;
        margin-right: 10px;
        background-repeat: no-repeat;
        background-position: center;
        background-color: white;
        z-index: 2;
    }

    &::after {
        content: "";
        position: absolute;
        left: 7px;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 15px;
        height: 15px;
        transition: var(--transition);
        border-radius: 100%;
        background: color(var(--csBlue) a(20%));
        z-index: 1;
    }
}

.tabs-component {} /*  "div" that holds tabs component */

.tabs-component-tabs { /* "ul" that holds tab navigation items */
    border-bottom: 1px solid var(--csBorder);
    margin-bottom: 40px;
}

.tabs-component-tab { /* "li" in tabs navigation */
    display: inline-block;
    margin-bottom: -1px;
    margin-right: 2px;
    transition: var(--transition);

    &.is-active {
        .tabs-component-tab-a { /* "anchor" in "li" in tabs navigation */
            border: 1px solid var(--csBorder);
            border-bottom: none;
            background: white;
            color: var(--csGray);
        }
    }
}

.tabs-component-tab-a { /* "anchor" in "li" in tabs navigation */
    border-radius: var(--radius) var(--radius) 0 0;
    display: block;
    padding: 0.7em 1em;
    border: 1px solid transparent;
    border-bottom: none;

    &:hover {
        background: var(--csBorder);
        color: var(--csGray);
        text-decoration: none;
    }
}

.tabs-component-panels {} /* "div" that wrap tabs content */
.tabs-component-panel {} /* "section" that holds 1 tab content */

/* utilities */
/* Visually hidden text, used for screen-readers */
.u-screenreader {
    position: absolute;
    left: -10000px;
    top: 0; /* 0 instead of auto because of issue with reserving vertical space in some cases */
    width: 1px;
    height: 1px;
    overflow: hidden;
}

.u-block {
    display: block;
}

.u-m0 {
    margin: 0;
}

.u-mb40 {
    margin-bottom: 40px;
}

.u-mt40 {
    margin-top: 40px;
}

.u-tac {
    text-align: center;
}

/* Grid */
.u-full {
    width: 100%;
    flex: none;
}

.u-auto {
    width: auto;
    flex: none;
}

.u-1of2 {
    width: 50%;
    flex: none;
}

.u-1of3 {
    width: 33.333333333333%;
    flex: none;
}

.u-2of3 {
    width: 0.666666667%;
    flex: none;
}

.u-1of4 {
    width: 25%;
    flex: none;
}

.u-3of4 {
    width: 75%;
    flex: none;
}

.u-1of5 {
    width: 20%;
    flex: none;
}

@media (--xsmall) {
    .u-xsmall-full {
        width: 100%;
        flex: none;
    }

    .u-xsmall-auto {
        width: auto;
        flex: none;
    }

    .u-xsmall-1of2 {
        width: 50%;
        flex: none;
    }

    .u-xsmall-1of3 {
        width: 33.333333333333%;
        flex: none;
    }

    .u-xsmall-2of3 {
        width: 66.666666667%;
        flex: none;
    }

    .u-xsmall-1of4 {
        width: 25%;
        flex: none;
    }

    .u-xsmall-3of4 {
        width: 75%;
        flex: none;
    }

    .u-xsmall-1of5 {
        width: 20%;
        flex: none;
    }
}

@media (--small) {
    .u-small-full {
        width: 100%;
        flex: none;
    }

    .u-small-auto {
        width: auto;
        flex: none;
    }

    .u-small-1of2 {
        width: 50%;
        flex: none;
    }

    .u-small-1of3 {
        width: 33.333333333333%;
        flex: none;
    }

    .u-small-2of3 {
        width: 0.666666667%;
        flex: none;
    }

    .u-small-1of4 {
        width: 25%;
        flex: none;
    }

    .u-small-3of4 {
        width: 75%;
        flex: none;
    }

    .u-small-1of5 {
        width: 20%;
        flex: none;
    }
}

@media (--medium) {
    .u-med-full {
        width: 100%;
        flex: auto; /* none */
    }

    .u-med-auto {
        width: auto;
        flex: auto; /* none */
    }

    .u-med-1of2 {
        width: 50%;
        flex: none;
    }

    .u-med-1of3 {
        width: 33.333333333333%;
        flex: none;
    }

    .u-med-2of3 {
        width: 0.666666667%;
        flex: none;
    }

    .u-med-1of4 {
        width: 25%;
        flex: none;
    }

    .u-med-3of4 {
        width: 75%;
        flex: none;
    }

    .u-med-1of5 {
        width: 20%;
        flex: none;
    }
}

@media (--xmedium) {
    .u-xmed-full {
        width: 100%;
        flex: auto;  /* none */
    }

    .u-xmed-auto {
        width: auto;
        flex: auto; /* none */
    }

    .u-xmed-1of2 {
        width: 50%;
        flex: none;
    }

    .u-xmed-1of3 {
        width: 33.333333333333%;
        flex: none;
    }

    .u-xmed-2of3 {
        width: 0.666666667%;
        flex: none;
    }

    .u-xmed-1of4 {
        width: 25%;
        flex: none;
    }

    .u-xmed-3of4 {
        width: 75%;
        flex: none;
    }

    .u-xmed-1of5 {
        width: 20%;
        flex: none;
    }
}

@media (--large) {
    .u-large-full {
        width: 100%;
        flex: none;
    }

    .u-large-auto {
        width: auto;
        flex: none;
    }

    .u-large-1of2 {
        width: 50%;
        flex: none;
    }

    .u-large-1of3 {
        width: 33.333333333333%;
        flex: none;
    }

    .u-large-2of3 {
        width: 0.666666667%;
        flex: none;
    }

    .u-large-1of4 {
        width: 25%;
        flex: none;
    }

    .u-large-3of4 {
        width: 75%;
        flex: none;
    }

    .u-large-1of5 {
        width: 20%;
        flex: none;
    }
}

/*-TABLE Adjustments---*/

.table-wrap td { 
    vertical-align: top; 
}

.table-wrap td ul {
    margin: 0;
}

.mobileview {
  display: none;
  text-align: center;
  padding: 15px 10px;
  font-size: 14px;
  color: #444;
  background: #f7f7f7;
  border-radius: 8px;
  margin: 10px auto;
  max-width: 350px;
  line-height: 1.4;
  border: 1px solid #e5e5e5;
}

.mobileview-text {
  margin-bottom: 8px;
  font-weight: 500;
}

@media only screen and (max-width: 768px) {
  .mobileview {
    display: block;
  }

  .mobileview img {
    max-width: 90px;
    display: block;
    margin: 0 auto;
  }
}


</style>
